enum Factors {
  BUILDING_AGE = 12,
  FINISHING_QUALITY = 13,
  // BASMENT = 14,
  NO_OF_FLOORS = 15,
}

export default Factors;
